import React from 'react';
import Modal from 'src/modules/shared/components/molecules/modals/modal';
import { Text } from 'src/modules/shared/components/atoms/text';
import { Template } from 'src/api/generated';
import TemplateList from '../template-list';
import TemplateModal from '../template-modal';
import { useAlert } from 'src/contexts/alert-context';
import { useDeleteTemplate } from 'src/modules/shared/messaging/hooks/api/templates';

interface TemplateListModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TemplateListModal: React.FC<TemplateListModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [editingTemplate, setEditingTemplate] = React.useState<
    Template | undefined
  >();
  const [isCreating, setIsCreating] = React.useState(false);
  const { showAlert } = useAlert();

  // TODO: check when implementing i18n
  const { deleteTemplate } = useDeleteTemplate({
    onSuccess: () => {
      showAlert('Plantilla eliminada correctamente', 'success');
    },
    onError: () => {
      showAlert('Error al eliminar plantilla', 'error');
    },
  });

  const handleDeleteTemplate = async (template: Template) => {
    if (window.confirm('¿Estás seguro de eliminar esta plantilla?')) {
      deleteTemplate(template.id);
    }
  };

  const handleCreateTemplate = () => {
    setIsCreating(true);
  };

  const handleCloseTemplateModal = () => {
    setEditingTemplate(undefined);
    setIsCreating(false);
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        header={
          <Text size="h5" color="neutral">
            {/* TODO: check when implementing i18n */}
            Plantillas rápidas
          </Text>
        }
        body={
          <TemplateList
            onEditTemplate={setEditingTemplate}
            onDeleteTemplate={handleDeleteTemplate}
            onCreateTemplate={handleCreateTemplate}
          />
        }
      />

      <TemplateModal
        isOpen={!!editingTemplate || isCreating}
        onClose={handleCloseTemplateModal}
        template={editingTemplate}
      />
    </>
  );
};

export default TemplateListModal;
